export default "__VITE_ASSET__BnktFOrY__"